// seo的页面不使用懒加载
import Layout from '@/views/layout/Layout'  //主页面
import Home from '@/views/layout/Home'  // 首页
import About from '@/views/about/About'  // 关于我们
import Baike from '@/views/baike/Baike'  // 产品及解决方案
import ContactUs from '@/views/contact/ContactUs'  // 产品及解决方案
import News from '@/views/news/News'  //
import NewsDetail from '@/views/news/NewsDetail'
const perfix = 'b-'
const routers = [
  {
    path: '/',
    component: Layout,
    children:[
      // 首页
      { name: `${perfix}index`, path: '', component: Home },
      // 保理知识
      { name: `${perfix}aboutUs`, path: 'about', component: About },
      // 保理法律法规
      { name: `${perfix}baiKe`, path: 'baike', component: Baike },
      // 留言
      { name: `${perfix}contact`, path: 'contact', component: ContactUs },
      // 最新资讯
      { name: `${perfix}news`, path: 'news', component: News },
      // 资讯详情
      { name: `${perfix}newsDetail`, path: 'newsDetail/:id', component: NewsDetail }
    ]
  }
]
export default routers